import styles from '@components/components/Vimeo/Vimeo.module.scss';
import NoConsentWidget from '@components/components/NoConsentWidget/NoConsentWidget';
import PropTypes from 'prop-types';
import React from 'react';
import { CheckConsent } from '@wienenergiegithub/modules-next/components';
import classNames from 'classnames';

const sizeToClassMap = {
  '300:169': 'xs',
  '570:320': 'sm',
  '741: 416': 'md',
  '912:513': 'lg',
  '1140:641': 'xl',
  '100%': 'full',
};

const Vimeo = ({
  autoCc,
  className,
  disableLazyLoading,
  hasControls,
  isAlbum,
  isAutoplay,
  isMuted,
  noCookies,
  onLoop,
  title,
  videoSize,
  vimeoId,
  ...props
}) => {
  const baseUrl = isAlbum
    ? `https://vimeo.com/album/${vimeoId}/embed`
    : `https://player.vimeo.com/video/${vimeoId}`;

  const url = new URL(
    `${baseUrl}?autoplay=${isAutoplay}&loop=${onLoop}&muted=${isMuted}&cookies=${noCookies}&controls=${hasControls}&cc=${autoCc}`,
  );

  return (
    <div
      className={classNames(
        styles.container,
        styles[sizeToClassMap[videoSize]],
        className,
      )}
      {...props}
    >
      <CheckConsent noConsent={NoConsentWidget} services={['vm']}>
        {/* While combining allow-scripts & allow-same-origin is strongly
        discouraged, it's also necessary for Vimeo videos to function. Since
        this component is exclusively used for Vimeo videos, which we
        consider a trusted source, the exception remains.
        See: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/iframe#sect6 */}
        {/* eslint-disable-next-line react/iframe-missing-sandbox */}
        <iframe
          allow="autoplay"
          allowFullScreen
          className={styles.video}
          sandbox="allow-scripts allow-same-origin"
          src={url?.href}
          title={title}
        />
      </CheckConsent>
    </div>
  );
};

Vimeo.propTypes = {
  autoCc: PropTypes.bool,
  className: PropTypes.string,
  disableLazyLoading: PropTypes.bool,
  hasControls: PropTypes.bool,
  isAlbum: PropTypes.bool,
  isAutoplay: PropTypes.bool,
  isMuted: PropTypes.bool,
  noCookies: PropTypes.bool,
  onLoop: PropTypes.bool,
  title: PropTypes.string.isRequired,
  videoSize: PropTypes.oneOf([
    '300:169',
    '570:320',
    '741: 416',
    '912:513',
    '1140:641',
    '100%',
  ]).isRequired,
  vimeoId: PropTypes.string.isRequired,
};

Vimeo.defaultProps = {
  autoCc: true,
  className: null,
  disableLazyLoading: false,
  hasControls: true,
  isAlbum: false,
  isAutoplay: true,
  isMuted: true,
  noCookies: true,
  onLoop: false,
};

export default Vimeo;
